import React, { useState } from 'react';
import { Card, Form, Button, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { createSite } from 'services/sites';
import { toast } from 'react-toastify';

const AddSite = () => {
  const [siteData, setSiteData] = useState({
    name: '',
    is_active: 1,
    header_color: '',
    footer_color: '',
    domain_name: ''
  });
  const [saving, setSaving] = useState(false);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    setSiteData({
      ...siteData,
      [name]: type === 'checkbox' ? (checked ? 1 : 0) : value
    });
    setErrors({
      ...errors,
      [name]: ''
    });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!siteData.name.trim()) newErrors.name = 'El nombre es requerido.';
    if (!siteData.domain_name.trim())
      newErrors.domain_name = 'El dominio es requerido.';
    return newErrors;
  };

  const handleSubmit = e => {
    e.preventDefault();
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      toast.error('Por favor, completa todos los campos requeridos.', {
        theme: 'colored'
      });
      return;
    }
    setSaving(true);
    createSite(
      siteData.name,
      siteData.is_active,
      siteData.header_color,
      siteData.footer_color,
      siteData.domain_name
    )
      .then(response => {
        if (response && response.result && response.id) {
          toast.success('Sitio creado exitosamente.', { theme: 'colored' });
          localStorage.setItem('selectedSiteId', response.id);
          navigate('/sites/edit');
        } else {
          toast.error('Error al crear el sitio.', { theme: 'colored' });
        }
        setSaving(false);
      })
      .catch(() => {
        toast.error('Error al crear el sitio.', { theme: 'colored' });
        setSaving(false);
      });
  };

  return (
    <Card>
      <Card.Header>
        <h5>Agregar Sitio</h5>
      </Card.Header>
      <Card.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>
              Nombre <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={siteData.name}
              onChange={handleChange}
              isInvalid={!!errors.name}
              placeholder="Nombre del sitio"
              size="sm"
            />
            <Form.Control.Feedback type="invalid">
              {errors.name}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Estado</Form.Label>
            <div>
              <Form.Check
                type="checkbox"
                name="is_active"
                checked={siteData.is_active === 1}
                onChange={handleChange}
                label={siteData.is_active === 1 ? 'Activo' : 'Inactivo'}
                className="mt-2"
              />
            </div>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Color Header</Form.Label>
            <div style={{ display: 'flex', gap: 8 }}>
              <Form.Control
                type="color"
                name="header_color"
                value={siteData.header_color || '#000000'}
                onChange={e =>
                  setSiteData({ ...siteData, header_color: e.target.value })
                }
                style={{ width: 40, padding: 0 }}
                title="Selecciona un color"
              />
              <Form.Control
                type="text"
                name="header_color"
                value={siteData.header_color || ''}
                onChange={e =>
                  setSiteData({ ...siteData, header_color: e.target.value })
                }
                placeholder="Pega un valor HEX o RGBA"
                size="sm"
              />
            </div>
            <Form.Text className="text-muted">
              Puedes seleccionar un color o pegar un valor como{' '}
              <code>#ff0000</code> o <code>rgba(255,0,0,1)</code>
            </Form.Text>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Color Footer</Form.Label>
            <div style={{ display: 'flex', gap: 8 }}>
              <Form.Control
                type="color"
                name="footer_color"
                value={siteData.footer_color || '#000000'}
                onChange={e =>
                  setSiteData({ ...siteData, footer_color: e.target.value })
                }
                style={{ width: 40, padding: 0 }}
                title="Selecciona un color"
              />
              <Form.Control
                type="text"
                name="footer_color"
                value={siteData.footer_color || ''}
                onChange={e =>
                  setSiteData({ ...siteData, footer_color: e.target.value })
                }
                placeholder="Pega un valor HEX o RGBA"
                size="sm"
              />
            </div>
            <Form.Text className="text-muted">
              Puedes seleccionar un color o pegar un valor como{' '}
              <code>#ff0000</code> o <code>rgba(255,0,0,1)</code>
            </Form.Text>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>
              Dominio <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              name="domain_name"
              value={siteData.domain_name}
              onChange={handleChange}
              isInvalid={!!errors.domain_name}
              placeholder="Ejemplo: midominio.com"
              size="sm"
            />
            <Form.Control.Feedback type="invalid">
              {errors.domain_name}
            </Form.Control.Feedback>
          </Form.Group>
          <Button variant="primary" type="submit" size="sm" disabled={saving}>
            {saving ? <Spinner animation="border" size="sm" /> : 'Crear Sitio'}
          </Button>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default AddSite;
